module.exports = __webpack_public_path__ + "img/team.fc4f0eed.png";